import React from 'react';

interface TimelineCardProps {
  year: string;
  title: string;
  description: string;
  image: string;
}

const TimelineCard: React.FC<TimelineCardProps> = ({ year, title, description, image }) => {
  return (
    <div className="w-full max-w-xs mx-auto sm:w-72 lg:w-auto xl:w-64 relative">
      {/* Year Badge - positioned at top center, outside the card */}
      <div className="absolute -top-3 sm:-top-5 left-1/2 transform -translate-x-1/2 bg-green-600 text-white px-4 py-1.5 sm:px-6 sm:py-2 rounded-full text-xs sm:text-sm font-semibold z-10">
        {year}
      </div>
             
      {/* Card Container - Responsive height */}
      <div className="bg-white rounded-[15px] sm:rounded-[20px] border border-gray-200 overflow-hidden w-full h-72 sm:h-80 flex flex-col mt-3 sm:mt-5">
        {/* Image Container - Responsive height */}
        <div className="relative h-40 sm:h-48 w-full overflow-hidden flex-shrink-0">
          <img 
            src={image}
            alt={title}
            className="w-full h-full object-cover"
          />
        </div>
                 
        {/* Content - Responsive padding and height */}
        <div className="h-32 p-3 sm:p-5 text-center bg-white flex flex-col justify-start">
          <div className="">
            <p className="text-[12px]  sm:text-sm text-black leading-relaxed font-medium">
              {title}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TimelineCard;